/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useState } from 'react';
import { Box, Button } from '@mui/material';
import MappingCreationForm from './MappingCreationForm';
import { Formik } from 'formik';
import * as Yup from 'yup';
import DialogContainer from '../../../../../components/shared/Dialog/DialogContainer';
import { toast } from 'react-toastify';
import { useDispatch } from 'react-redux';
import { getAllAccountMappings } from '../../../../../store/reducers/mapping/mappingAction';
import { createUserAccountMapping } from '../../../../../services/mapping/mapping';

const MappingCreation = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();

    // Handle open/close dialog
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);



    // Handle form submission
    const handleSubmit = async (values) => {
        try {
            await createUserAccountMapping(values);
            toast.success('Mapping was created successfully');
            await dispatch(getAllAccountMappings()).unwrap();

            handleClose();

        } catch (error) {
            toast.error(error?.response?.data?.error?.message);

            handleClose();

        }
    };
    return (
        <>
            <Button variant="contained" color="primary" style={{ float: 'right' }} onClick={handleOpen}>Add Account Mapping</Button>
            {/* Dialog for Adding MApping */}
            <DialogContainer
                open={open}
                handleClose={handleClose}
            >
                <Box sx={{ mt: 2 }}>
                    <Formik
                        initialValues={{
                            "getChkdID": "",
                            "applicationID": "",
                            "authProviderID": "",
                            "appUserID": "",

                        }}
                        validationSchema={Yup.object().shape({
                            getChkdID: Yup.string().required('GetChkd ID is required.'),
                            appUserID: Yup.string().required('User ID is required.'),
                            applicationID: Yup.string().required('Appication  is required.'),
                            authProviderID: Yup.string().required('Auth Provider is required.'),
                        })}
                        onSubmit={(
                            values
                        ) => {
                            handleSubmit(values)
                        }
                        }
                    >
                        {({ values, handleBlur, handleChange, isSubmitting, setFieldValue, errors, touched }) => (
                            <MappingCreationForm
                                values={values}
                                handleBlur={handleBlur}
                                handleChange={handleChange}
                                setFieldValue={setFieldValue}
                                isSubmitting={isSubmitting}
                                handleClose={handleClose}
                                errors={errors}
                                touched={touched} />)}
                    </Formik>
                </Box>

            </DialogContainer>
        </>
    )

}

export default MappingCreation;
